exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.unitSmallFont[data-v-8dea6a20] {\n    font-size: 0.8em;\n}\n", ""]);
